module.exports = __webpack_public_path__ + "static/media/question.372db43d.svg";